import { render } from "./nonAnnexureList.vue?vue&type=template&id=3be3173d&scoped=true"
import script from "./nonAnnexureList.vue?vue&type=script&lang=js"
export * from "./nonAnnexureList.vue?vue&type=script&lang=js"

import "./nonAnnexureList.vue?vue&type=style&index=0&id=3be3173d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be3173d"]])

export default __exports__